






import { Component, Vue, Prop } from 'vue-property-decorator';
import { Mutations, GlobalOverlays } from '@/ts/store/Constants';
import AssistantDialog from '@/components/Dialogs/AssistantDialog.vue';
import AddNewTicketType from '@/components/User/Panels/AddNewTicketType.vue';
import AddNewTicketCategory from '@/components/User/Panels/AddNewTicketCategory.vue';
import AddNewTicketInquiry from '@/components/User/Panels/AddNewTicketInquiry.vue';

@Component({
    components: {
        AssistantDialog,
        AddNewTicketType,
        AddNewTicketCategory,
        AddNewTicketInquiry,
    },
})
export default class ContentDialog extends Vue {
    @Prop() public overlay: string;
    @Prop() public closeAction: string;

    constructor() {
        super();
    }

    get ticketTypesOverlays() {
        return [GlobalOverlays.TICKET_CATEGORY, GlobalOverlays.TICKET_INQUIRY, GlobalOverlays.TICKET_TYPE];
    }

    public close() {
        this.$store.commit(this.closeAction, false);

        this.$store.commit(Mutations.SET_USER_CURRENT_TICKET_TYPE, []);
        this.$store.commit(Mutations.SET_USER_TICKET_ALL_CATEGORIES, []);

        this.$store.commit(Mutations.SET_GLOBAL_OVERLAY_COMPONENT, null);
        this.$store.commit(Mutations.SET_GLOBAL_OVERLAY_WAS_OPENED_LOCALLY, null);
        this.$store.commit(Mutations.SET_GLOBAL_OVERLAY_VISIBILITY, false);
    }
}
